import React from "react";
import { Form } from "semantic-ui-react";
import { FieldHeader } from "../FieldHeader";

const StringField = ({ id, label, value }: any) => {
  return (
    <Form.Field id={id} key={id}>
      <FieldHeader>{label}</FieldHeader>
      <p> {value} </p>
    </Form.Field>
  );
};

export default StringField;
